export enum HMSVideoViewMode {
  ASPECT_FILL = 'ASPECT_FILL',
  ASPECT_FIT = 'ASPECT_FIT',
  ASPECT_BALANCED = 'ASPECT_BALANCED',
}
